// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"ProfilePicture_Wrapper__1cTdU","Container":"ProfilePicture_Container__2TA57","Photo":"ProfilePicture_Photo__2XfVX"};